module.exports = __webpack_public_path__ + "0be72b0ff6f3c90e391aea2a6a874609.svg";